const dateOptions = [
    { label: "first_day", value: 1, range: 3, first: true },
    { label: "first_7_days", value: 7, range: 1, first: true },
    { label: "first_30_days", value: 30, range: 4, first: true },
    { label: "first_60_days", value: 60, range: 7, first: true }
];

export default dateOptions;